import { createSlice } from "@reduxjs/toolkit"

import logoIcon from "../../assets/images/logo-icon.svg?string"
import logoLandscape from "../../assets/images/logo-landscape.svg?string"
import logoMobile from "../../assets/images/logo-mobile.svg?string"
import logoPortrait from "../../assets/images/logo-portrait.svg?string"

/**
 *  Slice
 */
export type AppParamsType = {
  isAppWhitelabel: boolean
  appName: string
  appLogo: {
    portrait: string
    landscape: string
    icon: string
    mobile: string
  }
  appStore: {
    appleStoreURL: string
    googlePlayURL: string
  }
  appManifest: string
}

const initialState: AppParamsType = {
  isAppWhitelabel: false,
  appName: "Joan",
  appLogo: {
    icon: logoIcon,
    portrait: logoPortrait,
    landscape: logoLandscape,
    mobile: logoMobile,
  },
  appStore: {
    appleStoreURL:
      "https://apps.apple.com/az/app/joan-desk-booking/id1519226753",
    googlePlayURL:
      "https://play.google.com/store/apps/details?id=com.visionect.joan.desk",
  },
  appManifest: "/manifest.json",
}

const appParamsSlice = createSlice({
  name: "appParams",
  initialState,
  reducers: {
    changeAppParams: (state, action: { payload: AppParamsType }) => {
      state.isAppWhitelabel = action.payload.isAppWhitelabel
      state.appName = action.payload.appName
      state.appLogo = action.payload.appLogo
      state.appStore = action.payload.appStore
      state.appManifest = action.payload.appManifest
    },
  },
})

export const appParamsReducer = appParamsSlice.reducer
export const { changeAppParams } = appParamsSlice.actions
